import { Quote } from '../../types/quote'
import QuoteListItem from './QuoteListItem'
import styles from './QuoteList.module.css'

interface QuoteListProps {
  quotes: Quote[]
  onEdit: (quote: Quote) => void
  onDelete: (id: string) => void
}

function QuoteList({ quotes, onEdit, onDelete }: QuoteListProps) {
  return (
    <div className={styles.list}>
      {quotes.map((quote) => (
        <QuoteListItem
          key={quote.id}
          quote={quote}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  )
}

export default QuoteList
